import { CompatibilityResponse } from 'ctp-compatibility-checker';

export const EETS_SOFTWARE_UPDATE_NOTIFICATION = 'Update the DTCO software for EETS compatibility.';

export const requiresEetsSoftwareUpdate = (compatibility: CompatibilityResponse) => (
  compatibility.compatibleNotifications?.includes(EETS_SOFTWARE_UPDATE_NOTIFICATION) ?? false
);

export const extractCompatibleNotifications = (
  payload: CompatibilityResponse | CompatibilityResponse[]
) => {
  const responses = Array.isArray(payload) ? payload : [payload];

  return [...new Set(responses
    .flatMap(response => response.compatibleNotifications ?? [])
    .filter(notification => notification !== EETS_SOFTWARE_UPDATE_NOTIFICATION)
    .map(notification => notification?.trim())
    .filter((notification): notification is string => Boolean(notification)))];
};
